import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalIssueNavigatorBrowseRoute: InvariantJiraRoute = {
	name: 'legacy-gin-issue',
	path: '/browse/:issueKey?',
	query: ['jql|filter'],
};
